import React, { useCallback } from 'react';
import { Redirect, useLocalSearchParams, useRouter } from 'expo-router';

import { useIsFocused } from '@sg/garnish';

import { useCart } from '../../hooks';
import { Customization } from './components';

// ────────────────────────────────────────────────────────────────────────────────

export const CustomizationEditScreen = () => {
  const isScreenFocused = useIsFocused();
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationEditScreenRouteParams>();

  const { cart } = useCart();

  const { restaurantSlug, productSlug, lineItemId } = routeParams;

  const lineItems = cart?.lineItems;
  const isLineItemInCart = lineItems?.some(({ id }) => id === lineItemId);

  // ─────────────────────────────────────────────────────────────────

  const navigateToBag = useCallback(() => {
    try {
      router.dismissTo('/bag');
    } catch {
      // expo-router throws if called before Root Layout mounts
    }
  }, [router]);

  // ─────────────────────────────────────────────────────────────────

  // Redirect to the related menu screen if the line item isn't in the cart or has been removed
  if (isScreenFocused && !isLineItemInCart) {
    return <Redirect href={{ pathname: '/[restaurantSlug]/menu', params: { restaurantSlug } }} />;
  }

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Customization
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      lineItemId={lineItemId}
      isEditProductMode={true}
      onEditLineItemInCart={navigateToBag}
      onRemoveLineItemFromCart={navigateToBag}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationEditScreenRouteParams = {
  restaurantSlug: string;
  productSlug: string;
  lineItemId: string;
};
